import { NameValueBool } from '../models/name-value';

export class Bitdata {
  public static YesNo: NameValueBool[] = [
    { name: 'Yes', value: true },
    { name: 'No', value: false },
  ];
  public static YesNoMaybe: NameValueBool[] = [
    { name: '', value: false },
    { name: 'Yes', value: true },
    { name: 'No', value: false },
  ];

  public static TrueFalse: NameValueBool[] = [
    { name: '', value: false },
    { name: 'True', value: true },
    { name: 'False', value: false },
  ];
}